// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import axios from 'axios';
import QueryString from 'qs';
import {
  setupAuthInterceptor,
  useAuthTokenInterceptor,
  useAuthEmailQueryParamInterceptor,
  getAuthStateLazy,
} from './auth0';
import { trackPromise } from 'react-promise-tracker';
import { RTK_PROMISE_TRACKER_ID } from '@shared/data-access/utils/constants';
import { environment } from '@shared/environment';

const baseURL = environment.API.ENGINE_BASE_URL;

type FetchDataFuncProps = {
  endpoint: string;
  method: 'GET' | 'POST' | 'DELETE' | 'PUT';
  payload?: any;
  params?: any;
  signal?: AbortSignal;
  useTrackPromise?: boolean;
};

export const citecApi = setupAuthInterceptor(
  axios.create({
    baseURL,
    headers: {
      'Content-Type': environment.API_CONSTANTS.HEADERS.CONTENT_TYPE,
      accept: environment.API_CONSTANTS.HEADERS.ACCEPT,
    },
    timeout: environment.API_CONSTANTS.TIMEOUT_MS,
    paramsSerializer(params) {
      return QueryString.stringify(params, { encode: false });
    },
  }),
  getAuthStateLazy,
  useAuthTokenInterceptor,
  useAuthEmailQueryParamInterceptor,
);

export const fetchEngineApi = <T>({
  method,
  endpoint,
  payload,
  params,
  signal,
  useTrackPromise,
}: FetchDataFuncProps) => {
  return useTrackPromise
    ? trackPromise(
        citecApi.request<T>({
          method,
          url: endpoint,
          data: payload,
          params,
          signal,
        }),
        RTK_PROMISE_TRACKER_ID,
      )
    : citecApi.request<T>({
        method,
        url: endpoint,
        data: payload,
        params,
        signal,
      });
};
